import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const LANGUAGES = [
	{ code: "fr", label: "Français" },
	{ code: "ar", label: "العربية" },
];

const LanguageSwitcher = ({ as = "li", className = "nav-item", toggleClassName = "nav-link i-false c-pointer d-flex align-items-center" }) => {
	const { i18n } = useTranslation();
	const currentLang = LANGUAGES.find((l) => l.code === i18n.language) || LANGUAGES[0];

	return (
		<Dropdown as={as} className={className}>
			<Dropdown.Toggle as="a" className={toggleClassName}>
				<i className="ti ti-language fs-20 me-1"></i>
				<span className="tw-text-sm tw-uppercase">{currentLang.code}</span>
			</Dropdown.Toggle>
			<Dropdown.Menu align="end" className="dropdown-menu-end">
				{LANGUAGES.map((lang) => (
					<Dropdown.Item
						key={lang.code}
						active={lang.code === i18n.language}
						onClick={() => i18n.changeLanguage(lang.code)}
					>
						{lang.label}
					</Dropdown.Item>
				))}
			</Dropdown.Menu>
		</Dropdown>
	);
};

export default LanguageSwitcher;